module.exports = __webpack_public_path__ + "img/2023big17.766a3748.png";